<template>
  <div>
    <p class="title">>>常见问题解答</p>
    <p class="content" v-html="content"></p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content:
        "Q1：“网络游戏未成年人家长监护机制工程”是什么？<br>\
        “网络游戏未成年人家长监护工程”是一项由完美时空、腾讯、盛大游戏、网易、搜狐畅游、巨人网络六家网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。它提供了一种切实可行的方法，一种家长实施监控的管道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注以及对用实际行动营造和谐社会的愿望。<br>\
        <br>\
        Q2：什么情况下需要申请该项服务呢？<br>\
        在监护人发现被监护人有沉溺海南搜易科技游戏的情况下，监护人可向海南搜易科技公司申请发起未成年人家长监护机制。<br>\
        <br>\
        Q3：申请该项服务时需要提交哪些资料呢？如何提交呢？<br>\
        申请人需通过邮寄方式向我司提交《海南搜易科技游戏未成年人用户家长监控服务申请书》及其中所提及需提供的附件，包含：<br>\
        <br>\
        附件1：申请人的身份证（复印件）<br>\
        <br>\
        附件2：被申请人的身份证（复印件）<br>\
        <br>\
        附件3：申请人与被申请人的监护法律关系证明文件（户口簿或者其他合法有效证明文件）<br>\
        <br>\
        您在填写《海南搜易科技游戏未成年人用户家长监控服务申请书》时，请提供尽可能详尽、真实的玩家资料，以便帐号归属的判定。<br>\
        <br>\
        Q4：相关资料寄往哪里呢？<br>\
        请将相关资料邮寄至：（请在信封表面写上“家长监控服务申请书”的字样）<br>\
        收件人：海南搜易科技有限公司 <br>\
        地　址：海南省省直辖县级行政单位澄迈县老城高新技术产业示范区海南生态软件园A09-101<br>\
        <br>\
        Q5：提交资料后，后续处理流程怎样呢？<br>\
        您提交相关申请资料后，我司客服人员将按照监护申请流程尽快处理您的申请，处理过程中可能需要对监护人和被监护人进行电话回访以便信息的判定，希望您的配合。<br>\
        <br>\
        Q6：判定帐号归属需要多久呢？<br>\
        在判断申请材料完整的情况下，我司将联系疑似账号归属者，告知其在 15 个自然日内将按照监护人需求对其账号进行相关操作，并要求疑似账号归属者提供身份材料以便我司判定其与监护人监护关系；<br>\
        若疑似账号归属者在 15 个自然日内不能提供有效身份证明或逾期提供，则默认为疑似账号归属者与被监护人身份相符。我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；<br>\
        若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人相符，我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；<br>\
        若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人不符，我司则无法判定其与被监护人的身份关系。在此情况下，为保障用户游戏账号安全，我司将通知监护人通过公安机关出具账号找回协查证明，由我司协助被监护人找回游戏账号后再进行后续操作；<br>\
        <br>\
        Q7:若发现对帐号归属有疑义或账号被恶意防沉迷限制怎么办？<br>\
        您需要在收到通知后15个自然日内提供您的身份证复印件（纸质），并通过以下地址邮寄到我司，如果我司在15个自然日内未收到您的身份证复印件，我们会将您的账号纳入家长监控系统。<br>\
        <br>\
        <br>\
        注1：请在身份证复印件上写明您的签名以及游戏账号。<br>\
        <br>\
        注2：请您注意我司提供该项服务不收取任何费用，以免上当受骗。"
    };
  },
  mounted: function() {},
  methods: {}
};
</script>
<style scoped>
.title {
  color: #ef653d;
  width: 900px;
  font-size: 20px;
  text-align: left;
  margin:0 auto;
  padding: 50px 0 0px;
}
.content {
  width: 900px;
  margin: 0 auto;
  padding: 20px 0 150px;
  font-size: 15px;
  color: #5d5d5d;
  text-align: left;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/useQuestion.vue